import idea from "../../assets/aboutAssets/Idea.svg";
import assess from "../../assets/aboutAssets/Assessment.svg";
import profile from "../../assets/aboutAssets/Profile.svg";
import "./index.css";

const About = () => (
  <>
    <div className="about-container" id="about">
      <p className="about-text">
        We provide comprehensive educational support tailored to each student’s
        need, <br /> ensuring academic excellence with holistic development
      </p>
      <div className="about-cards">
        <div className="card-1">
          <img src={idea} alt="Concept Clarity" />
          <h5 className="card-header">Concept Clarity</h5>
          <p className="card-description">
            Our teaching methodology focuses on building strong conceptual
            understanding rather than rate learning, ensuring long-term
            retention and application.
          </p>
        </div>
        <div className="card-2">
          <img src={profile} alt="Individual Attention" />
          <h5 className="card-header">Individual Attention</h5>
          <p className="card-description">
            Small batch sizes ensure personalized attention to each student,
            addressing their unique learning needs and helping them overcome
            challenges.
          </p>
        </div>
        <div className="card-3">
          <img src={assess} alt="Regular Assessments" />
          <h5 className="card-header">Regular Assessments</h5>
          <p className="card-description">
            Periodic tests and assessments help track progress, identify
            improvement areas, and prepare students for board and competitive
            examinations.
          </p>
        </div>
      </div>
    </div>
  </>
);

export default About;
